import resources from './resources';

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'es',
  resources,
};

export { resources };
